import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import ThesaurusFolderIcon from '../ThesaurusFolderIcon';
import ThesaurusExpandButton from '../ThesaurusExpandButton';
import Button from '@Components/Button';


export default function ThesaurusItemFolderInfo(props) {
  const {
    item,
    title,
    isOpen,
    selected,
    isFolder,
    onToggleGroup,
    partiallySelected,
    onClickThesaurusItem,
  } = props;

  return (
    <>
      <ThesaurusExpandButton
        item={item}
        isOpen={isOpen}
        isFolder={isFolder}
        onToggleGroup={onToggleGroup}
      />

      <Button
        buttonConfig={{
          type: 'link',
          size: 'xs',
          title,
          label: title,
          e2eName: 'thesaurus-item',
          noBorder: true,
          className: 'tree-view-dialog-thesaurus-item-info',
          labelWrapperClassName: 'tree-view-dialog-thesaurus-item-info-title-wrapper'
        }}
        onClick={() => {
          onClickThesaurusItem(item);
        }}
      >
        <ThesaurusFolderIcon
          selected={selected}
          partiallySelected={partiallySelected}
        />
      </Button>
    </>
  );
}

ThesaurusItemFolderInfo.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  partiallySelected: PropTypes.bool.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};
